import { render, staticRenderFns } from "./CreatePlaylist.vue?vue&type=template&id=d84e2598&"
import script from "./CreatePlaylist.vue?vue&type=script&lang=js&"
export * from "./CreatePlaylist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports